import {
    type Permission,
    type AnyRole,
    getPermissionAssignments,
} from '@precon-tools-suite-by-shared/js-precon-rbac';

function* permissionIterator(
    roles: Iterable<AnyRole>,
    extraPermissions: Iterable<Permission>
) {
    for (const role of roles) {
        yield* getPermissionAssignments(role).values();
    }

    yield* extraPermissions;
}

export function createPermissionSet(
    roles: Iterable<AnyRole> | undefined | null,
    extraPermissions: Iterable<Permission> | undefined | null
): ReadonlySet<Permission> {
    return new Set(permissionIterator(roles ?? [], extraPermissions ?? []));
}
